<template>
  <div>
    <v-app-bar
      app
      height="96"
      absolute
      hide-on-scroll
    >
      <div class="d-flex align-center">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-app-bar-nav-icon>
        <v-img
          alt="Editora do Brasil"
          class="shrink ml-4"
          contain
          src="@/assets/logo-ebsa-fonte-azul.svg"
          transition="scale-transition"
          width="142"
        />
        <v-toolbar-title class="pl-6 pt-2 primary--text hidden-md-and-up">
          <v-img
          alt="Consultor Digital"
          class="shrink"
          contain
          src="@/assets/consultor-digital-mobile.svg"
          transition="scale-transition"
          width="108"
        />
        </v-toolbar-title>
        <v-toolbar-title class="pl-16 primary--text hidden-sm-and-down">
          <v-img
          alt="Consultor Digital"
          class="shrink"
          contain
          src="@/assets/consultor-digital.svg"
          transition="scale-transition"
          width="276"
        />
        </v-toolbar-title>
      </div>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn class="primary--text" to="//editoradobrasil.com.br/faleconosco" target="_blank" text>Contato</v-btn>
        <!-- <v-btn to="//www.editoradobrasil.com.br/sistemas/cadastro" target="_blank" text>Meu Dados</v-btn> -->
        <!-- <div>
          Olá,
          <span>Fulano</span>!
          Sair.
        </div> -->
        <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
          class="primary--text"
            text
            v-bind="attrs"
            v-on="on"
          >
            Olá, <span v-text="userName">Fulano.</span> <v-icon right>keyboard_arrow_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <!--<v-list-item>
            <v-list-item-title>
              <v-btn text block class="primary--text">Meus Dados</v-btn>
            </v-list-item-title>
          </v-list-item>-->
          <v-list-item>
            <v-list-item-title>
              <v-btn @click="sair()" text block class="primary--text">Sair</v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      </v-toolbar-items>
    </v-app-bar>
      <v-navigation-drawer class="menu-header-mobile" v-model="drawer" absolute temporary>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          active-class="primary--text text--accent-4"
        >
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-icon color="primary">person</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title><span  v-text="userName">Fulano</span></v-list-item-title>
            <!-- <v-list-item-subtitle>Logged In</v-list-item-subtitle> -->
            </v-list-item-content>
          </v-list-item>
         <!-- <v-list-item>
           <v-list-item-icon>
              <v-icon color="primary">person</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              Olá, <span  v-text="userName">Fulano</span>.
            </v-list-item-title>
          </v-list-item> -->
          <v-divider class="mb-4"></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="primary">mail</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <a class="primary--text" href="//editoradobrasil.com.br/faleconosco" target="_blank">Contato</a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-icon>
              <v-icon color="primary">person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <a class="primary--text" href="//editoradobrasil.com.br/sistemas/cadastro" target="_blank">Meus Dados</a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-divider class="mt-4 mb-4"></v-divider>

          <v-list-item>
            <v-list-item-icon>
              <v-icon color="primary">logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <a class="primary--text" @click="sair()" href="#">Sair</a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>


export default {
  name: 'HeaderLogado',

  data: () => ({
    drawer: false,
    userName: "",
  }),
  watch: {
    group () {
      this.drawer = false
    },
    //userName: function (val) {
      //if(val == ""){ return; }
      //this.abrirFlipbook(val.arquivo);
      //console.log(val);
      //this.query = "";
      //this.selected = "";
    //}
  },
  created() {
    try {
        const storage = JSON.parse(localStorage.getItem('user'));
        this.userName =  storage.userName.split(' ')[0];
        //this.Usuario = storage.usuario.nome
        //this.Guid = storage.usuario.guid
    }
    catch (error) {
      console.log(error);
    }
  },
  methods: {
      sair() {
      let self = this;
      localStorage.clear();
      self.$router.push('/');
    }
  }
};
</script>
<style lang="scss">
header {
  background: rgba(255, 255, 255, 0.4) !important;
  .v-toolbar__title {
    font-size: 36px !important;
  }
  .v-btn__content {
    font-weight: bold;
  }
  .v-icon {
    color:#19286E !important;
  }
}
.menu-header-mobile {
  a {
    text-decoration: none;
    display: block;
  }
}
</style>
